import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { UserSessionStateService } from '../services/user-session-state.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    private readonly userSession = inject(UserSessionStateService);

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const headers: Record<string, string> = {
            'X-Request-Id': `client-${uuidv4()}`,
        };

        const token = this.userSession.getSessionId();
        if (token) {
            headers['X-PLG-Session'] = token;
        }

        return next.handle(req.clone({ setHeaders: headers }));
    }
}
